import React from 'react';

import styled from '@emotion/styled';

import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import UserOverview from './UserOverview';
import UserTable from './UserTable';

const UserManagement = () => {
  return (
    <Page title='Logirate | User Management'>
      <PageLayout>
        <Container>
          <UserOverview />
          <UserTable />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default UserManagement;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
